import classNames from 'classnames';
import type { ReactNode } from 'react';

import { Alert } from '@sravni/react-design-system/lib/Alert';
import { Icon } from '@sravni/react-design-system/lib/Icon';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Text } from '@sravni/react-design-system/lib/Typography';
import { CoinsPlus } from '@sravni/react-icons';
import { useBoolean } from '@sravni/react-utils';

import { Question } from '@src/components/icons';
import { CurrencySymbol } from 'shared/config/internalization';

import { PromoGuideSheet } from '../PromoGuideSheet';

import styles from './PromoInfoBox.module.scss';

interface Props {
  children: ReactNode;
  isUserFromGoogleSearch: boolean;
}

export const PromoInfoBox = ({ children, isUserFromGoogleSearch }: Props) => {
  const [visible, toogle] = useBoolean();

  return (
    <Alert
      className={classNames(styles.alert, { [styles.blueAlert]: isUserFromGoogleSearch })}
      title={
        <Space direction="row" justify="center" size={4} align="center" className={styles.alertContent}>
          <Icon className={classNames(styles.icon, 'h-color-static-light')} icon={<CoinsPlus />} />
          <Text size={14} className={classNames(styles.bonusTitle, 'h-color-static-light')}>
            Бонус от Сравни
          </Text>
          <Space direction="horizontal" className={styles.container}>
            <Text size={14} className="h-color-static-light">
              +500 {CurrencySymbol.RUB}
            </Text>
            <Icon className={styles.icon} onClick={toogle.on}>
              <Question />
            </Icon>
          </Space>
        </Space>
      }
    >
      <div>{children}</div>

      <PromoGuideSheet visible={visible} onClose={toogle.off} onButtonClick={toogle.off} />
    </Alert>
  );
};
